import { useEffect } from 'react'

const useSetChartDataVariable = (inputParam_ChartData, series, _aux_chartData_dates, data, setData) => {
    useEffect(() => {
        const doIt = async () => {
            try {
                const config = 
                {          
                    series: series,
                    options: {
                        chart: {
                          type: 'bar',
                          height: 350,
                          stacked: true,
                          toolbar: {
                            show: true
                          },
                          zoom: {
                            enabled: true
                          }
                        },
                        responsive: [{
                          breakpoint: 480,
                          options: {
                            legend: {
                              position: 'bottom',
                              offsetX: -10,
                              offsetY: 0
                            }
                          }
                        }],
                        plotOptions: {
                          bar: {
                            horizontal: false,
                            borderRadius: 10
                          },
                        },
                        xaxis: {
                          categories: _aux_chartData_dates,
                        },
                        legend: {
                          position: 'right',
                          offsetY: 40
                        },
                        fill: {
                          opacity: 1
                        }
                    }
                }
                setData(config)
            }
            catch (error) {
            }
        }

        if (inputParam_ChartData !== null && data === null) {
            doIt()
        }

    }, [inputParam_ChartData, series, _aux_chartData_dates, data, setData])
}

export default useSetChartDataVariable